import {PutHealthRescheduleAppointmentsParams} from 'domain/usecases';
import {makePutHealthRescheduleAppointments} from 'main/factories/usecases';

export async function putHealthRescheduleAppointments(
	params: PutHealthRescheduleAppointmentsParams,
) {
	const response = await makePutHealthRescheduleAppointments().put(params);

	return response;
}
